import { useState } from "react";

import MCubeEngageWhatsappPhoneNumbers from "./MCubeEngageWhatsappPhoneNumbers";
import MCubeEngageWhatsappTemplates from "./MCubeEngageWhatsappTemplates";

import useMCubeEngageWhatsappTemplates from "./useMCubeEngageWhatsappTemplates";

const TABS = {
  PHONE_NUMBERS: "Phone numbers",
  TEMPLATES: "Templates",
} as const;

const MCubeEngageWhatsappManagerRegistry = {
  [TABS.PHONE_NUMBERS]: MCubeEngageWhatsappPhoneNumbers,
  [TABS.TEMPLATES]: MCubeEngageWhatsappTemplates,
};

export default function MCubeEngageWhatsappManager(props) {
  const { isViewOnly, workspaceId, configuration, fetchConfiguration } = props;
  const [activeTab, setActiveTab] = useState(TABS.PHONE_NUMBERS);
  const { templates } = useMCubeEngageWhatsappTemplates(workspaceId);

  const tabs = Object.values(TABS).map((tab) => ({
    name: tab,
    current: tab === activeTab,
    href: "#",
  }));

  const MCubeEngageWhatsappManagerTab =
    MCubeEngageWhatsappManagerRegistry[activeTab];

  return (
    <MCubeEngageWhatsappManagerTab
      templates={templates}
      configuration={configuration}
      workspaceId={workspaceId}
      fetchConfiguration={fetchConfiguration}
      tabs={tabs}
      setActiveTab={setActiveTab}
      disabled={isViewOnly}
    />
  );
}
